import { HTTP } from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const ChangeInvoiceStatusStore = {
    namespaced: true,
    state: {
        searchModel: {
            compCode: "",
            DateFrom: common.currentMonth(),
            DateTo: common.todayDate(),
            DateDeliveryFrom: "1900-01-01",
            DateDeliveryTo: "2099-12-31",
            DateAddFrom: "1900-01-01",
            DateAddTo: "2099-12-31",
            EntNum: "",
            RefNum: "",
            OthRefNum: "",
            Salesman: "",
            Warehouse: "",
            TxPrfx: "",
            TxNumFrom: "",
            TxNumTo: "",
            ItemNumFrom: "",
            ItemNumTo: "",
            FromDeliveryLocation: "",
            ToDeliveryLocation: "",
            OutLocFrm: "",
            OutLocTo: "",
            TxStatus: "",
            AprvStatus: "10,20,30,97"
        }
    },
    actions: {
        getOutStandingSOList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/so/getOutStandingSOList', param).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        getInvoiceList({ commit, state }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/getinvlist', param).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        convertSOToInvoice({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/so/convertSOToInvoice', { soNums: param.soNums }).then(response => {
                    resolve(response);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
    }
};
export default ChangeInvoiceStatusStore;